<template>
  <div class="flex w-full px-2 sm:px-0 flex-col">
    <div class="flex justify-end mb-3 sm:mb-5">
      <button
              @click="back()"
              class=" flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white py-4 sm:py-2 px-4 rounded-full sm:rounded-lg">
        <ArrowLeftIcon class="sm:mr-2 self-center" size="1.1x"></ArrowLeftIcon>
        <span class="hidden sm:inline">Back</span>
      </button>
    </div>
    <div class="flex w-full justify-center">
      <div class="rounded shadow-2xl bg-white flex flex-col sm:p-5 p-3 w-full sm:w-full lg:w-1/2 xl:w-1/3">
        <div class="flex justify-between">
          <p class="text-2xl mb-5 font-semibold capitalize text-purple_dark self-center">
            Edit {{state}}
          </p>
          <!--        <span class=" self-start">-->
          <!--          <FolderPlusIcon class="text-blue-500" size="2x"></FolderPlusIcon>-->
          <!--        </span>-->
        </div>
        <div class="w-full">
          <ValidationObserver ref="observe" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)" class="">
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  State
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="State"
                         type="text" v-model="editObj.state">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Contact
                </label>
                <ValidationProvider rules="required|numeric|min:11" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Phone Number"
                         type="text" v-model="editObj.number">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex items-center justify-between mt-6">
                <button class="bg-purple w-full hover:bg-red-dark-700 text-white  py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="submit">
                  Publish Changes
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div></template>

<script>

  import {ArrowLeftIcon} from "vue-feather-icons";
  import {db} from "../../db";
  import {eventBus} from "../../eventbus";
  export default {
    name: "NumberEdit",
    props: {
      editObj: {
        type: Object
      },
      numberKeys: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      key: '',
      state:''
    }),
    components: {
      // Edit3Icon,
      ArrowLeftIcon
    },
    methods: {
      onSubmit() {
        db.ref('numbers/').child(this.key).update({
          state: this.editObj.state.toLowerCase(),
          number: this.editObj.number
          // eslint-disable-next-line no-unused-vars
        }).then(res => {
          this.$toast.open({
            message: 'Successful',
            type: 'success'
          });
          eventBus.$emit('AllNumber')
        }).catch(
            // eslint-disable-next-line no-unused-vars
            err => {
              this.$toast.open({
                message: 'Something Went Wrong ' + err,
                type: 'error'
              });
            }
        )
      },
      findKey() {
        let state = this.numberKeys.find(item => item.state === this.editObj.state);
        this.key = state.key
        this.state = state.state

      },
      back() {
        eventBus.$emit('AllNumber')
      }
    },
    created() {
      this.findKey()
    }
  }
</script>

<style scoped>

</style>